import cn from 'classnames';
import SmallCaps from 'components/typography/small-caps';
import locales from 'constants/locales';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { FormattedMessage } from 'react-intl';

interface LocaleSwitcherProps {
  className?: string;
}

const availableLocales = [
  { code: locales.DE, label: 'Deutsch' },
  { code: locales.EN, label: 'English' },
];

/**
 * LocaleSwitcher component allows users to switch between German and English locales.
 */
const LocaleSwitcher: React.FC<LocaleSwitcherProps> = ({ className }) => {
  const { locale, pathname, query } = useRouter();

  return (
    <div className={className}>
      <SmallCaps>
        <div className="text-primary-main mb-2 text-center whitespace-nowrap lg:text-left">
          <FormattedMessage id="footer:link-section:language-switcher" />
        </div>
      </SmallCaps>
      <nav aria-label="Language Switcher" data-test="locale-switcher">
        <ul className="flex justify-center space-x-4 md:justify-start">
          {availableLocales.map(({ code, label }) => (
            <li key={code}>
              <Link href={{ pathname, query }} locale={code} scroll={false}>
                <span
                  className={cn(
                    'text-grey-700 lg:hover:text-grey-900 block text-sm lg:text-base',
                    locale === code ? 'underline underline-offset-4' : ''
                  )}
                  aria-current={locale === code ? 'page' : undefined}
                  data-test={`locale-switcher-${code}`}
                >
                  {label}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default LocaleSwitcher;
